import React from "react";
import { bool, node, number, string } from "prop-types";
import Section from "../Section";
import { Col, Container, Row } from "../Grid";
import Panel from "../Panel";
import { classes } from "../utils/classes";
import { bgColorBlack2 } from "../utils/color";
import { sxClassName, sxProps, sxPropTypes } from "../props/sx";
import { utilityClassName, utilityProps, utilityPropTypes } from "../props/utility";

const SimpleTemplate = ({
	cellWidth = 8,
	mdCellWidth = 10,
	paddingTop = "pt-9 pt-9--md",
	paddingBottom = "pb-18 pb-18--md",
	panel = true,
	panelPaddingY = 16,
	panelUtility = { ...utilityProps },
	children,
	bgColor = bgColorBlack2,
	className = "",
	shadow = true,
	utility = { ...utilityProps },
	sx = { ...sxProps },
	...props
}) => {
	return (
		<Section
			className={classes(
				paddingTop,
				paddingBottom,
				!(utility && utility.bgColor) && bgColor,
				...utilityClassName(utility),
				...sxClassName(sx),
				className,
			)}
			{...props}
		>
			<Container>
				<Row px utility={{ justify: "center" }}>
					<Col md={mdCellWidth} lg={cellWidth}>
						{panel ? (
							<Panel shadow={shadow} utility={panelUtility} spacing={{ py: panelPaddingY }}>
								<Row mx px utility={{ justify: "center" }}>
									<Col md={10}>{children}</Col>
								</Row>
							</Panel>
						) : (
							children
						)}
					</Col>
				</Row>
			</Container>
		</Section>
	);
};

SimpleTemplate.propTypes = {
	shadow: bool,
	cellWidth: number,
	mdCellWidth: number,
	paddingTop: string,
	paddingBottom: string,
	panel: bool,
	panelPaddingY: number,
	panelUtility: utilityPropTypes,
	children: node.isRequired,
	bgColor: string,
	utility: utilityPropTypes,
	sx: sxPropTypes,
	className: string,
};

export default SimpleTemplate;
